module.exports = __webpack_public_path__ + "60d729a5acee39613e223bb59567fd5e.otf";